import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section id="precio" className="py-20 md:py-32 bg-[#0a0a0a] relative overflow-hidden text-center" data-id="element-89">
      <div className="absolute inset-0 bg-gradient-to-t from-cyan-900/10 to-transparent pointer-events-none" data-id="element-90" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[400px] md:w-[800px] h-[200px] md:h-[400px] bg-cyan-500/10 blur-[80px] md:blur-[100px] rounded-full pointer-events-none" data-id="element-91" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-93">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-4 md:mb-6 leading-tight" data-id="element-94">
            No sigas viviendo con esa sensación de{' '}
            <span className="text-red-500" data-id="element-95">arrastrar el día</span>
          </h2>

          <p className="text-base md:text-xl text-gray-300 mb-8 md:mb-10 max-w-2xl mx-auto" data-id="element-96">
            Tu cuerpo sabe cómo recuperarse si le das las señales correctas. Haz
            clic abajo y accede de inmediato a "Longevidad Activa 35+" + Bonus.
          </p>

          <div className="flex justify-center" data-id="element-97">
            <CTAButton className="px-8 md:px-12 py-4 md:py-5 text-base md:text-xl" data-id="element-98">
              QUIERO RECUPERAR MI ENERGÍA HOY
            </CTAButton>
          </div>

          <p className="mt-4 md:mt-6 text-xs md:text-sm text-gray-500" data-id="element-99">
            Acceso inmediato • Pago seguro • Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}